export const getThirdPartyTagViewStyle = () => ({
  container: {
    fontSize: '14px',
    marginLeft: 26,
    marginTop: 10,
    marginBottom: 12,
    '& .copy-tag': {
      display: 'inline-block',
    },
    '& a.HelpTopic, & a.all-platforms-learn-more': {
      marginLeft: 15,
      'vertical-align': 'middle',
    },
  },
});
